export default {
  fontSize: '1rem',
  fontWeight: '400',
  titleFontSize: '1.5rem',
  letterSpacing: 'normal',
  gridTemplateMobile: 'repeat(auto-fill, minmax(100%, auto))',
  gridTemplateDesktop: 'repeat(auto-fill, minmax(32%, auto))',
};
